import Vue from 'vue'

import {
  Button,
  Toast,
  Dialog,
  Popup,
  Icon,
  PasswordInput,
  NumberKeyboard,
  CountDown,
  Switch,
  DatetimePicker,
  Swipe, 
  SwipeItem,
  Checkbox,
  Tab, 
  Tabs
} from 'vant'

Vue.use(Button)
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
Vue.use(CountDown);
Vue.use(Switch);
Vue.use(DatetimePicker);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Checkbox);
Vue.use(Tab);
Vue.use(Tabs);